import { FiscalAddress, PostalAddress } from 'common';

export const addressValuesAreEmpty = (address: PostalAddress | FiscalAddress) =>
    !address?.street && !address?.postalCode && !address?.city && !address?.country;

export const DOCTYPE_ID_FRONT = 50;
export const DOCTYPE_ID_BACK = 60;
export const DOCTYPE_ID_BUSINESS = 117;
export const DOCTYPE_VAT = 24;
